import type { IFile, IFileModel } from '@/types/globalTypes'
export const News = (json: INews): INewsModel => {
	const fromJSON = (json: INews) => {
		const { meta_canonical, meta_description, meta_robots, language, created_at, updated_at, files, ...rest } = json
		return {
			...rest,
			metaCanonical: meta_canonical,
			metaDescription: meta_description,
			metaRobots: meta_robots,
			language: language?.toUpperCase(),
			createdAt: created_at,
			updatedAt: updated_at,
			files: files ? files.map((file) => FileModel(file)) : [],
		}
	}

	return { ...fromJSON(json) }
}

export const newsToJSON = (obj: Partial<INewsModel>): Partial<INews> => {
	const { metaCanonical, metaDescription, metaRobots, language, createdAt, updatedAt, files, ...rest } = obj

	return {
		...rest,
		meta_canonical: metaCanonical,
		meta_description: metaDescription,
		meta_robots: metaRobots,
		language: language?.toLowerCase(),
		created_at: createdAt,
		updated_at: updatedAt,
		files: files ? [] : [],
	}
}

export const FileModel = (json: IFile): IFileModel => {
	const fromJSON = (json: IFile) => {
		const { created_at, updated_at, full_path, model_id, model_type, ...rest } = json
		return {
			...rest,
			createdAt: created_at,
			updatedAt: updated_at,
			fullPath: full_path,
			modelId: model_id,
			modelType: model_type,
		}
	}

	return { ...fromJSON(json) }
}

export const FileFromJSON = (json: IFile): IFileModel => {
	const fromJSON = (json: IFile) => {
		const { created_at, updated_at, full_path, model_id, model_type, ...rest } = json
		return {
			...rest,
			createdAt: created_at,
			updatedAt: updated_at,
			fullPath: full_path,
			modelId: model_id,
			modelType: model_type,
		}
	}

	return { ...fromJSON(json) }
}
